import Vue from 'vue'
import App from './App.vue'
//import VueNotification from "vue-notification";
import VueSweetalert2 from "vue-sweetalert2";
import vSelect from "vue-select";
import pdf from "vue-pdf";


import router from './router';
import store from './store';
import http from "./http";

import './utils/fontawesome';
import './utils/filters';

import TokenService from "./services/token.service";
import 'sweetalert2/dist/sweetalert2.min.css';

import "vue-select/dist/vue-select.css";
import './assets/css/animate.min.css'
import './assets/css/vue-tabs.css'
//import './assets/css/nprogress.css'
//import './assets/js/nprogress.js'
//import './assets/js/vue-tabs.js'
import './assets/css/bulma.min.css'
import './assets/js/fontawesome/all.js'
//import './assets/js/chart.min.js'
/*
<link rel="stylesheet" href="/src/assets/css/animate.min.css"/>
    <title>CoreEFF | Corendon Airlines</title>
<link rel="stylesheet" href="/src/assets/css/vue-tabs.css" />
    <link rel="stylesheet" href="/src/assets/css/nprogress.css" />
    <script src="/src/assets/js/nprogress.js"></script>
    <script src="/src/assets/js/vue-tabs.js"></script>
    <link rel="stylesheet" href="/src/assets/css/bulma.min.css">
    <script defer src="/src/assets/js/fontawesome/all.js"></script>
    <script src="/src/assets/js/chart.min.js"></script>
*/

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

Vue.config.devtools = true;
Vue.config.productionTip = false;

//Vue.use(VueNotification);

Vue.use(VueSweetalert2);
Vue.use(pdf);
//Vue.use(nProgress);
Vue.component("v-select", vSelect);



http.init();

if (TokenService.getAccessToken()) {
    http.setHeader();
    http.mountAuthInterceptor();
}

Vue.config.devtools = true

new Vue({
    render: h => h(App),
    router,
    store
}).$mount('#app');
